import React from "react";
import FormComponent from "../components/FormComponent";

function Banner() {
    return (
        <>
            <section id="banner" className="position-relative">
                <div className="container-lg g-0">
                    <div className="row g-0">
                        <div className="col-md-7 col-xl-4 position-relative z-3 banner-wrapper">
                            <div className="bannerlist mt-3 px-3 px-lg-0">
                                <h1>Curated for your lifestyle.<br />Packed with perks</h1>
                                <h2 className="subtitle">
                                    No Joining Fee & No Annual Fee<sup>#</sup>
                                </h2>
                                <img src="dist/img/cards_mob.webp" alt="" className="img-fluid mt-3 d-block d-md-none" width={358} height={138} />
                                <img src="dist/img/Ban_New_00.webp" data-gif="dist/img/No_Fee_Page.gif"  width={440} height={265} alt={"multicards Banner"} className="swap img-fluid d-none d-md-block" />
                            </div>
                        </div>
                        <div className="col-md-5 col-xl-4 videowrap p-md-4 p-lg-0">
                            <img src="dist/img/Ban_New_00.webp" data-gif="dist/img/No_Fee_Page.gif"  width={440} height={265} alt={"multicards Banner"} className="swap img-fluid d-block d-md-none"/>
                            <img src="dist/img/card_desktop.webp" alt="" className="d-none d-md-block" width={374} height={419} />
                        </div>
                        <div className="col-md-12 col-xl-4 px-3">
                            <FormComponent></FormComponent>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Banner;
